<template>
  <ion-app>
    <div class="ion-page">
      <ion-header class="ion-no-border">
        <ion-toolbar color="dark" mode="ios">
          <ion-title>Self Order</ion-title>
        </ion-toolbar>
      </ion-header>

      <ion-loading :is-open="showLoading" message="Memproses pesanan..." spinner="circles"></ion-loading>

      <ion-content class="ion-padding-horizontal">
        <div class="header-section">
          <h3>Lengkapi Detail Pesanan</h3>
          <p class="subtitle">Informasi ini diperlukan untuk memproses pembayaran instan Anda.</p>
        </div>

        <div class="form-container">
          <div class="input_group">
            <label :class="{ 'label-error': errors.customer }">Nama Anda</label>
            <input type="text" v-model="customer" class="modern-input" :class="{ 'input-error': errors.customer }"
              placeholder="Masukkan nama lengkap" />
            <small v-if="errors.customer" class="error-text">{{ errors.customer }}</small>
          </div>

          <!-- WhatsApp field no longer needed
          <div class="input_group">
            <label :class="{ 'label-error': errors.whatsapp }">No. WhatsApp</label>
            <div class="input-with-prefix">
              <span class="prefix">+62</span>
              <input type="tel" v-model="whatsapp" class="modern-input prefix-input"
                :class="{ 'input-error': errors.whatsapp }" placeholder="81xxxxxxx" />
            </div>
            <small v-if="errors.whatsapp" class="error-text">{{ errors.whatsapp }}</small>
          </div>
          -->

          <div class="input_group">
            <label :class="{ 'label-error': errors.table }">No. Meja</label>
            <input type="text" v-model="table" class="modern-input" :class="{ 'input-error': errors.table }"
              placeholder="Contoh: 12" />
            <small v-if="errors.table" class="error-text">{{ errors.table }}</small>
          </div>

          <div class="input_group">
            <label>Catatan Tambahan (Opsional)</label>
            <textarea rows="3" v-model="notes" class="modern-textarea"
              placeholder="Contoh: Jangan terlalu pedas, ya!"></textarea>
          </div>
        </div>
      </ion-content>

      <ion-footer class="ion-no-border">
        <div class="footer-action ion-padding">
          <ion-button @click="handlePayment()" expand="block" class="main-confirm-btn" :disabled="isLoading">
            <ion-spinner v-if="isLoading" name="crescent"></ion-spinner>
            <span v-else>Lanjutkan ke Pembayaran</span>
          </ion-button>
        </div>
      </ion-footer>
      <insufficient-stock-modal
        :is-open="showStockModal"
        :items="outOfStockItems"
        @close="showStockModal = false"
        @edit-order="handleEditOrder"
      />
    </div>
  </ion-app>
</template>

<script>
import { useOutletStore } from "@/stores/outlet"
import { getMessagingIfSupported, getToken, onMessage } from "@/firebase";
import { IonApp, IonButton, IonContent, IonHeader, IonLoading, IonTitle, IonToolbar, IonFooter, IonSpinner, alertController } from "@ionic/vue";
import { storage, STORAGE_KEYS, setCurrentInvoice } from "@/utils/storage";
import { identifyLogRocket } from "@/utils/logrocket";
import InsufficientStockModal from "@/components/insufficientStockModal.vue";

export default {
  components: {
    IonLoading,
    IonApp,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonButton,
    IonFooter,
    IonSpinner,
    InsufficientStockModal
  },
  data() {
    return {
      showLoading: false,
      customer: "",
      whatsapp: "",
      table: "",
      notes: "",
      errors: {},
      isLoading: false,
      firebaseToken: "",
      showStockModal: false,
      outOfStockItems: [],
    }
  },
  async created() {
    const messaging = await getMessagingIfSupported();
    if (!messaging) {
      console.warn("Firebase messaging not supported on this browser.");
      return;
    }

    try {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("🚫 Izin notifikasi ditolak.");
        return;
      }

      // ✅ getToken sekarang fungsi, bukan method
      const token = await getToken(messaging, {
        vapidKey: process.env.VUE_APP_VAPID_KEY,
      });

      console.log("✅ Firebase Token:", token);
      this.firebaseToken = token;

      // ✅ Listener pesan masuk
      onMessage(messaging, (payload) => {
        console.log("📩 Pesan diterima:", payload);
        const { title, body } = payload.notification;
        new Notification(title, { body });
      });
    } catch (error) {
      console.error("❌ Error mendapatkan Firebase Token:", error);
    }

    const outletStore = useOutletStore();

    if (outletStore.orderList.length === 0) {
      this.$router.replace({ name: "homePage" });
    }
  },
  computed: {
    outletStore() {
      return useOutletStore()
    }
  },
  mounted() {
    const customer = storage.getCustomer()

    if (customer) {

      const phone = customer.phone?.toString() || ""

      const normalizedPhone = phone
        .replace(/^62/, "")
        .replace(/^0/, "")

      this.customer = customer.name
      this.whatsapp = normalizedPhone
      this.table = customer.table

      identifyLogRocket({ name: this.customer, waNumber: phone })
    }
  },
  methods: {
    validateForm() {
      this.errors = {}

      if (!this.customer) {
        this.errors.customer = "Nama wajib diisi"
      } else if (this.customer.length < 3) {
        this.errors.customer = "Nama minimal 3 huruf"
      }

      if (!this.whatsapp) {
        // WhatsApp no longer required
      }

      // if (!this.table) {
      //   this.errors.table = "Nomor meja wajib diisi"
      // }

      return Object.keys(this.errors).length === 0
    },
    getInsufficientStockItems(insufficientStockObj, orderList = []) {
      if (!insufficientStockObj || typeof insufficientStockObj !== "object") {
        return [];
      }

      const ids = Object.keys(insufficientStockObj);
      const items = [];

      ids.forEach(id => {
        let found = null;

        if (Array.isArray(orderList)) {
          for (const item of orderList) {
            if (item.product_detail_id == id || item.product_id == id) {
              found = {
                id,
                name: item.product_name || item.name,
                photo: item.photo || item.image || ""
              };
              break;
            }
            const extraSource = item.link_menu || item.extra;
            if (extraSource && Array.isArray(extraSource)) {
              for (const group of extraSource) {
                const details = group.link_menu_detail || [group];
                if (Array.isArray(details)) {
                  for (const detail of details) {
                    if (detail.product_detail_fkid == id || detail.product_detail_id == id) {
                      found = {
                        id,
                        name: detail.product_name || detail.name,
                        photo: detail.photo || ""
                      };
                      break;
                    }
                  }
                }
                if (found) break;
              }
            }
            if (found) break;
          }
        }

        items.push(found || { id, name: `Produk (ID: ${id})`, photo: "" });
      });

      return items;
    },
    handleEditOrder() {
      this.showStockModal = false;
      const outlet = this.outletStore.outlet;
      const outletId = outlet?.outlet_id || this.$route.params.id;
      this.$router.push(`/${outletId}`);
    },
    async handlePayment() {
      const outlet_id = this.$route.params.id;
      if (!this.validateForm()) {
        return
      }
      storage.removeMultiple([
        STORAGE_KEYS.ORDER_DEADLINE,
        STORAGE_KEYS.ACTIVE_ORDER,
        STORAGE_KEYS.HAS_ACTIVE_ORDER
      ])

      this.isLoading = true
      this.showLoading = true
      try {
        const custumer = {
          name: this.customer,
          phone: `0${this.whatsapp}`,
          table: this.table.toString(),
        }
        const outlet = this.outletStore.outlet
        const orderList = this.outletStore.orderList

        const myHeaders = new Headers();
        myHeaders.append("Public-Key", `${process.env.VUE_APP_PUBLIC_KEY}=`);

        const body = {
          outlet_id: outlet.outlet_id,
          order_type: "dine_in",
          order_list: [...orderList],
          customer: custumer,
          order_note: this.notes,
          firebase_token: this.firebaseToken,
        };

        storage.setCustomer(custumer)
        identifyLogRocket({ name: custumer.name, waNumber: custumer.phone })

        const requestOptions = {
          method: "POST",
          body: JSON.stringify(body),
          headers: myHeaders,
          redirect: "follow",
        };

        const url = `${process.env.VUE_APP_BASE_URL}v2/transaction`
        const res = await fetch(url, requestOptions)
        const data = await res.json().catch(() => null)

        if (res.ok && data && (data.status === true || data.data?.order_sales_id)) {
          this.showLoading = false
          const invoice = data.data.order_sales_id
          this.outletStore.setCurrentInvoice(invoice)
          setCurrentInvoice(invoice)
          const newDeadline = Math.floor(Date.now() / 1000) + 24 * 60 * 60;
          storage.setPaymentOrderDeadline(newDeadline)
          storage.setHasActiveOrder("1")
          storage.setLastOrderStatus("diterima")
          const lastOrder = storage.getLastOrder()
          if (lastOrder && lastOrder.outlet_id == outlet_id) {
            storage.setActiveOrder({ outlet_id, products: lastOrder.products })
          }
          this.$router.push(`/${outlet.outlet_id}/order/payment/qris/waiting`)
        } else {
          this.showLoading = false
          const insufficientStockObj = data?.data?.insufficient_stock || data?.insufficient_stock;
          if (insufficientStockObj && Object.keys(insufficientStockObj).length > 0) {
            this.outOfStockItems = this.getInsufficientStockItems(insufficientStockObj, orderList);
            this.showStockModal = true;
          } else {
            const errorMsg = data?.message || "Gagal membuat pesanan. Silakan coba lagi.";
            const alert = await alertController.create({
              header: 'Gagal Membuat Pesanan',
              message: errorMsg,
              buttons: ['OK']
            });
            await alert.present();
          }
        }
      } catch (err) {
        this.showLoading = false
        console.error("Request gagal:", err)
        const alert = await alertController.create({
          header: 'Kesalahan Sistem',
          message: 'Terjadi kesalahan saat memproses pesanan. Silakan coba lagi.',
          buttons: ['OK']
        });
        await alert.present();
      } finally {
        this.isLoading = false
        this.showLoading = false
      }
    }
  }
}
</script>

<style scoped>
/* Layout & Background */
ion-content {
  --background: #ffffff;
}

.header-section {
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 2rem;
}

.header-section h3 {
  font-weight: 800;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.subtitle {
  color: #7f8c8d;
  font-size: 0.9rem;
  padding: 0 1rem;
}

/* Form Styling */
.form-container {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.input_group {
  display: flex;
  flex-direction: column;
}

.input_group label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #34495e;
  margin-bottom: 0.5rem;
  margin-left: 4px;
}

/* Input Fields */
.modern-input,
.modern-textarea {
  width: 100%;
  background-color: #f8f9fa;
  border: 1.5px solid #ecf0f1;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 1rem;
  color: #2c3e50;
  transition: all 0.3s ease;
}

.modern-input:focus,
.modern-textarea:focus {
  outline: none;
  border-color: #d9833b;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(217, 131, 59, 0.1);
}

/* Prefix WhatsApp */
.input-with-prefix {
  display: flex;
  align-items: center;
  background-color: #f8f9fa;
  border: 1.5px solid #ecf0f1;
  border-radius: 12px;
}

.prefix {
  padding-left: 16px;
  color: #7f8c8d;
  font-weight: 600;
}

.prefix-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* Error States */
.input-error {
  border-color: #e74c3c !important;
}

.label-error {
  color: #e74c3c !important;
}

.error-text {
  color: #e74c3c;
  font-size: 0.75rem;
  margin-top: 4px;
  margin-left: 4px;
}

/* Footer & Button */
ion-footer {
  background: white;
}

.main-confirm-btn {
  --background: #d9833b;
  --border-radius: 14px;
  --box-shadow: 0 4px 12px rgba(217, 131, 59, 0.25);
  height: 54px;
  font-weight: 700;
  margin: 0;
}

/* Fix for IOS safe area */
.footer-action {
  padding-bottom: calc(1rem + var(--ion-safe-area-bottom));
}
</style>